import React, { Component, useState } from 'react';
import { Router, Switch } from 'react-router-dom';
import { Redirect, Route } from 'react-router';
import Login from './login/Login';
import '../style/global.scss';
import './App.scss';
import { setConfiguration } from 'react-grid-system';
import history from '../utils/history';
import Users from './users/Users';
import Companies from './companies/Companies';
import NotFound from './not-found/NotFound';
import { PublicRoute, PrivateRoute } from './AuthRoutes';
import Container from './container/Container';
import Intercom from './intercom/Intercom';
import FreeTrials from './free-trials/FreeTrials';
import ChangeCard from './change-card/ChangeCard';
import ChangeBillingDate from './change-billing-date/ChangeBillingDate';
import ChangeCancellationDate from './change-cancellation-date/ChangeCancellationDate';
import SpreedlyPaymentLogs from './spreedly-payment-logs/SpreedlyPaymentLogs';
import PaymentLogs from './payment-logs/PaymentLogs';
import { ConfigConstants } from '../utils/config';
import TwoFactorAuthLogin from './login/two-factor-auth-login/TwoFactorAuthLogin';

setConfiguration({ gutterWidth: 10 });

class App extends Component {
  render() {
    const isProd = ConfigConstants.reactAppEnvironment === "Production"

    return (
      <Router history={history}>
        <Switch>
          <Container>
            <PublicRoute exact path="/login" component={Login} />
            <PublicRoute exact path="/two-factor-authentication" component={TwoFactorAuthLogin} />
            <PrivateRoute exact path="/users" component={Users} />
            <PrivateRoute exact path="/intercom" component={Intercom} />
            <PrivateRoute exact path="/companies" component={Companies} />
            {/* <PrivateRoute exact path="/free-trials" component={FreeTrials} /> */}
            <PrivateRoute exact path="/change-card" component={!isProd ? ChangeCard : NotFound} />
            {/*<PrivateRoute exact path="/change-billing-date" component={ChangeBillingDate} />*/}
            <PrivateRoute exact path="/change-cancellation-date" component={ChangeCancellationDate} />
            <PrivateRoute exact path="/spreedly-payment-logs" component={SpreedlyPaymentLogs} />
            <PrivateRoute exact path="/payment-logs" component={PaymentLogs} />
            <Redirect exact from="/" to="/users" />
            <Route path="*" component={NotFound} />
          </Container>
        </Switch>
      </Router>
    )
  }
}

export default App;